import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-200">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <div className="text-2xl font-bold">
              <span className="text-sky-600">Hristina</span>
              <span className="text-slate-800"> Vassileva</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-slate-700 hover:text-sky-600 transition-colors font-medium">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="text-slate-700 hover:text-sky-600 transition-colors font-medium">
              About
            </button>
            <button onClick={() => scrollToSection('services')} className="text-slate-700 hover:text-sky-600 transition-colors font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('experience')} className="text-slate-700 hover:text-sky-600 transition-colors font-medium">
              Experience
            </button>
            <button onClick={() => scrollToSection('gallery')} className="text-slate-700 hover:text-sky-600 transition-colors font-medium">
              Gallery
            </button>
            <button onClick={() => scrollToSection('videos')} className="text-slate-700 hover:text-sky-600 transition-colors font-medium">
              Videos
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-slate-700 hover:text-sky-600 transition-colors font-medium">
              Testimonials
            </button>
            <Button onClick={() => scrollToSection('contact')} className="bg-sky-600 hover:bg-sky-700 text-white">
              Contact
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-slate-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-4 border-t border-slate-200">
            <div className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('home')} className="text-slate-700 hover:text-sky-600 transition-colors font-medium text-left">
                Home
              </button>
              <button onClick={() => scrollToSection('about')} className="text-slate-700 hover:text-sky-600 transition-colors font-medium text-left">
                About
              </button>
              <button onClick={() => scrollToSection('services')} className="text-slate-700 hover:text-sky-600 transition-colors font-medium text-left">
                Services
              </button>
              <button onClick={() => scrollToSection('experience')} className="text-slate-700 hover:text-sky-600 transition-colors font-medium text-left">
                Experience
              </button>
              <button onClick={() => scrollToSection('gallery')} className="text-slate-700 hover:text-sky-600 transition-colors font-medium text-left">
                Gallery
              </button>
              <button onClick={() => scrollToSection('videos')} className="text-slate-700 hover:text-sky-600 transition-colors font-medium text-left">
                Videos
              </button>
              <button onClick={() => scrollToSection('testimonials')} className="text-slate-700 hover:text-sky-600 transition-colors font-medium text-left">
                Testimonials
              </button>
              <Button onClick={() => scrollToSection('contact')} className="bg-sky-600 hover:bg-sky-700 text-white w-full">
                Contact
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;